export default {"src":"/_next/static/media/eye-closed.c4b08aee.svg","height":512,"width":513};